export default __webpack_public_path__ + "static/media/passenger-app.80de5d64.png";